import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/usage/user.usage.query.gql"
import type {
  UserUsageQuery,
  UserUsageQueryVariables,
} from "@/v2-backoffice-client/user/usage/__types__/user.usage.query"

type Options = QueryHookOptions<UserUsageQuery, UserUsageQueryVariables>

export function useUserUsageQuery(options?: Options) {
  return useQuery<UserUsageQuery, UserUsageQueryVariables>(query, options)
}
